import React from "react";
import { connect } from "react-redux";
import $ from "jquery";
import { toast } from "react-toastify";

class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.recievedCode = this.props.location.state.data;
    this.state = {
      number: "",
      studentType: 1,
      password: "",
      confirmPassword: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    localStorage.clear();
    $(document).ready(function () {
      $("#vmc-form-link").click(function (e) {
        $("#vmc-form").delay(100).fadeIn(100);
        $("#nonvmc-form").fadeOut(100);
        $("#nonvmc-form-link").removeClass("active");
        $('#non-vmc').addClass("non-vmc");
        $('#vmc').removeClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
      $("#nonvmc-form-link").click(function (e) {
        $("#nonvmc-form").delay(100).fadeIn(100);
        $("#vmc-form").fadeOut(100);
        $("#vmc-form-link").removeClass("active");
        $('#non-vmc').removeClass("non-vmc");
        $('#vmc').addClass("vmc")
        $(this).addClass("active");
        e.preventDefault();
      });
    });
  }

  handleChange(e) {
    if (document.getElementById("vmc-form-link").className === "active") {
      this.setState({
        studentType: 1,
      });
    } else {
      this.setState({
        studentType: 0,
      });
    }
    const { name, value } = e.target;
    this.setState({ [name]: value });
  }

  handleSubmit(e) {
    e.preventDefault();

    const { number, studentType, password, confirmPassword, code } = this.state;
    if (this.state.password === "" || this.state.code === "" || this.state.number === "") {
      toast.error("Please fill the details");
    } else if (code !== this.recievedCode) {
      toast.error("OTP Code doesn't match");
    } else if (password !== confirmPassword) {
      toast.error("Password doesn't match");
    } else {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          number,
          studentType,
          password,
        })
      };
      let url = "http://15.206.132.121:3002/api/resetPassword";
      return fetch(url, requestOptions)
        .then(response => response.json())
        .then((data) => {
          if (!data.success) {
            throw data.message
          }
          window.alert(`Your password has been reset. Please login with new Password`)
          this.props.history.push('/')
        })
        .catch(err =>
          toast.error("Password Reset Failed. Either wrong input or System error", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined
          })
        );
    }
  }

  render() {
    const { number, code, password, confirmPassword } = this.state;
    return (
      <div>
        <div className="login-body">
          <div className="container ">
            <div className="logo" style={{ textAlign: "center" }}>
              <img
                src="https://www.vidyamandir.com/assets/images/vmc_logo.png"
                alt="VidyaMandir"
                style={{ marginTop: "3%", backgroundColor: "#1FB5AD" }}
              />
            </div>
            <div className="row">
              <div
                className="panel-heading"
                style={{
                  maxWidth: "330px",
                  height: "42px",
                  margin: "100px auto",
                  marginTop: "60px",
                  marginBottom: "-1px",
                  padding: '0'
                }}>
                <div style={{
                  height: "100%"
                }}>
                  <div style={{
                    height: "100%",
                    display: 'flex',
                    border: '2px solid darkgray',
                    borderBottom: 0

                  }}>
                    <div className="form-flex" id="vmc">
                      <a
                        className="active"
                        id="vmc-form-link"
                        style={{
                          display: "flex",
                          justifyContent: "center"
                        }}>
                        <strong>VMC Student</strong>
                      </a>
                    </div>
                    <div className="form-flex non-vmc" id="non-vmc"
                    >
                      <a id="nonvmc-form-link">
                        <strong>Non-VMC Student</strong>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <form
                className="form-signin"
                id="vmc-form"
                style={{ display: "block", marginTop: "0" }}
                onSubmit={this.handleSubmit}>
                <div className="login-wrap">
                  <div className="user-login-info">
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="number"
                      placeholder="Enter Roll number"
                      value={number}
                      onChange={this.handleChange}
                    />
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="code"
                      placeholder="Enter Code"
                      value={code}
                      onChange={this.handleChange}
                    />
                    <input
                      type="password"
                      className="form-control fixed-height"
                      name="password"
                      placeholder="Enter New Password"
                      value={password}
                      onChange={this.handleChange}
                    />
                    <input type="password" className="form-control" placeholder="Confirm New Password" name="confirmPassword" value={confirmPassword} onChange={this.handleChange} />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-lg btn-login btn-block">
                    <strong>Reset Password</strong>
                  </button>
                </div>
              </form>
              <form
                className="form-signin"
                id="nonvmc-form"
                style={{ display: "none", marginTop: "0" }}
                onSubmit={this.handleSubmit}>
                <div className="login-wrap">
                  <div className="user-login-info">
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="number"
                      placeholder="Enter Registration number"
                      value={number}
                      onChange={this.handleChange}
                    />
                    <input
                      type="text"
                      className="form-control fixed-height"
                      name="code"
                      placeholder="Enter OTP Code"
                      value={code}
                      onChange={this.handleChange}
                    />
                    <input
                      type="password"
                      className="form-control fixed-height"
                      name="password"
                      placeholder="Enter New Password"
                      value={password}
                      onChange={this.handleChange}
                    />
                    <input type="password" className="form-control" placeholder="Confirm New Password" name="confirmPassword" value={confirmPassword} onChange={this.handleChange} />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-lg btn-login btn-block">
                    <strong>Reset Password</strong>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const connectedResetPassword = connect()(ResetPassword);
export { connectedResetPassword as ResetPassword };